var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMemberGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    color: "inherit",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0453 15.1495H0.631297C0.23673 15.1495 0 14.9128 0 14.5183V5.68107C0 5.28655 0.23673 5.0498 0.631297 5.0498H17.0453C17.4398 5.0498 17.6766 5.28655 17.6766 5.68107V14.5183C17.6766 14.9128 17.4398 15.1495 17.0453 15.1495ZM1.26259 13.8871H16.414V6.31234H1.26259V13.8871Z",
    color: "inherit"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.52539 5.68093V3.15605C2.52539 2.76153 2.76217 2.52478 3.15673 2.52478H19.5707C19.9652 2.52478 20.202 2.76153 20.202 3.15605V11.9932C20.202 12.3878 19.9652 12.6245 19.5707 12.6245H17.0454V11.362H18.9394V3.78722H3.78803V5.68093H2.52539Z",
    color: "inherit"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.83817 13.2559C7.10208 13.2559 5.68164 11.8357 5.68164 10.0998C5.68164 8.36388 7.10208 6.9436 8.83817 6.9436C10.5743 6.9436 11.9947 8.36388 11.9947 10.0998C11.9947 11.8357 10.6532 13.2559 8.83817 13.2559ZM8.83817 8.20605C7.8123 8.20605 6.94428 9.07402 6.94428 10.0998C6.94428 11.1255 7.8123 11.9935 8.83817 11.9935C9.86404 11.9935 10.7321 11.1255 10.7321 10.0998C10.7321 9.07402 9.86404 8.20605 8.83817 8.20605Z",
    color: "inherit"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.05078 3.15614V0.631171C5.05078 0.236653 5.28751 0 5.68207 0H22.096C22.4906 0 22.7273 0.236653 22.7273 0.631171V9.46843C22.7273 9.86295 22.4906 10.0996 22.096 10.0996H19.5708V8.83716H21.4646V1.26244H6.31342V3.15614H5.05078Z",
    color: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemberGroup);
export default __webpack_public_path__ + "static/media/member-group.277205126ecdd30cf9dee5e2a1223747.svg";
export { ForwardRef as ReactComponent };